import EditProductPrices from '@/components/product-prices/EditProductPrices'

export default [
  {
    path: '/editProductPrices',
    name: 'editProductPrices',
    component: EditProductPrices,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/productPricesRoutes.js